<!--
 * @Author: hongqi
 * @LastEditors: hongqi
 * @Date: 2021-01-09 09:04:20
 * @LastEditTime: 2021-01-09 10:02:02
-->
<template>
    <div>
        <img src="../../../assets/newImg/childCompanyDetail_bg_img.png" class="bg" alt="">
        <div style="height:.3rem"></div>
        <div class="detail">
            <img :src="userDetail.avatar" alt="">
            <div class="detail-intro">
                <div class="detail-status">子公司状态 · 营业中</div>
                <div class="detail-time">创建时间：{{userDetail.is_subsidiary_time_date}}</div>
            </div>
        </div>
        <div style="height:.3rem"></div>
        <div class="intro">
            <div class="title">子公司介绍</div>
            <div class="html" v-html="childDetail"></div>
            <div style="height:.3rem"></div>
        </div>
        <div style="height:.3rem"></div>
    </div>
</template>

<script>
import { childDetail, getUserInfo } from "@api/user";
export default {
    data() {
        return {
            childDetail: {},
            userDetail: {},
        };
    },
    mounted() {
        this._onShowLoading();
        if (this.$route.query.token && this.$route.query.token.length > 0) {
            let token = this.$route.query.token
            let time = this.$route.query.expires_time
            const datas = {
                token: token,
                expires_time: time
            };
            this.$store.commit("LOGIN", datas);
        }
        this._onGetuserInfo();
        this.getChildDetail();
    },
    methods: {
        getChildDetail() {
            childDetail()
                .then((res) => {
                    console.log(res);
                    this.childDetail = res.msg;
                    this._onHideLoading();
                })
                .catch((error) => {
                    this._onHideLoading();
                })
        },
        _onGetuserInfo() {
            getUserInfo().then((res) => {
                console.log(res);
                this.userDetail = res.data;
            });
        },
    },
};
</script>
<style scoped>
   .html>>>img{
        width: 100%;
        display: block;
    }
</style>
<style lang="scss" scoped>
.intro {
    background: #ffffff;
    border-radius: 0.1rem;
    box-shadow: 0px 0.02rem 0.3rem 0px rgba(157, 157, 157, 0.2);
    margin: 0 0.2rem;
    .title {
        width: 100%;
        font-size: 0.32rem;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #333333;
        height: 1.05rem;
        position: relative;
        &::before {
            position: absolute;
            bottom: 0;
            left: 0.88rem;
            right: 0.88rem;
            height: 0.02rem;
            background: #f0f0f0;
            content: "";
        }
    }
    .html {
        font-size: 0.24rem;
        color: #333333;
        margin: 0.3rem 0.88rem 0;
    }
    
}
.detail {
    display: flex;
    align-items: center;
    padding: 0.22rem 0.34rem;
    box-sizing: border-box;
    background: #ffffff;
    margin: 0 0.3rem;
    border-radius: 0.1rem;
    img {
        width: 1.36rem;
        border-radius: 100%;
        height: 1.36rem;
        object-fit: cover;
    }
    .detail-intro {
        margin-left: 0.26rem;
        flex: 1;
        .detail-status {
            font-size: 0.3rem;
            font-weight: 600;
            color: #333333;
            letter-spacing: 0.02rem;
        }
        .detail-time {
            margin-top: 0.12rem;
            font-size: 0.24rem;
            color: #999999;
        }
    }
}
.bg {
    width: 100%;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    z-index: -1;
}
</style>